import { createFileRoute } from '@tanstack/react-router'

import { profileQuery, settingsQuery } from '../lib/queries'
import { Settings } from '../screens/Settings'

export const Route = createFileRoute('/settings')({
  loader: ({ context }) =>
    Promise.all([
      context.queryClient.ensureQueryData(settingsQuery()),
      context.queryClient.ensureQueryData(profileQuery()),
    ]),
  component: Settings,
})
